import { useParams, Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <div className="pt-20 px-4 md:px-6 py-20 text-center">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-3">分类未找到</h1>
        <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm">
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <>
      <SEOHead
        title={`${category.name} - 亚洲国产高清${category.name}精选 | 亚洲国产高清影视内容精选平台`}
        description={`${category.description}，亚洲国产高清为您精选最优质的亚洲国产高清${category.name}内容。`}
        keywords={`亚洲国产高清${category.name},国产高清${category.name},亚洲高清${category.name}资源,${category.name}在线观看`}
        canonicalUrl={`https://loforce.cn/category/${slug}`}
      />

      <div className="pt-20">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: category.name },
          ]}
        />

        <section className="px-4 md:px-6 py-10">
          <div className="max-w-7xl mx-auto">
            <div className="mb-10">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                {category.name}
              </h1>
              <p className="text-foreground-600 text-sm md:text-base">{category.description}</p>
            </div>

            <div className="flex gap-3 mb-8 overflow-x-auto pb-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-label font-medium transition-colors whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300"
                  >
                    <div className="relative aspect-video overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-black/60 backdrop-blur-sm rounded-full">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                        <span className="text-white text-xs font-label font-medium">{article.rating}</span>
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">{article.excerpt}</p>
                      <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.viewCount > 10000 ? `${(article.viewCount / 10000).toFixed(0)}万` : article.viewCount}
                        </span>
                        <span>·</span>
                        <span>{article.year}</span>
                        <span>·</span>
                        <span>{article.region}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-200/70">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
}